/**
 * Formatea una fecha string (YYYY-MM-DD o YYYYMMDD) a DD/MM/YYYY
 * Evita problemas de timezone parseando manualmnete los componentes.
 */
export const formatDate = (dateString) => {
    if (!dateString) return '-';

    // Si es YYYYMMDD (8 caracteres)
    if (dateString.length === 8 && /^\d{8}$/.test(dateString)) {
        return `${dateString.substring(6, 8)}/${dateString.substring(4, 6)}/${dateString.substring(0, 4)}`;
    }

    // Si es YYYY-MM-DD (10 caracteres)
    if (dateString.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    }

    // Fallback para otros formatos (ISO con hora, etc)
    try {
        const d = new Date(dateString);
        // Usar UTC methods para evitar shifts si viene como ISO sin timezone
        // O mejor, usar toLocaleDateString con UTC timezone si queremos ser estrictos
        // Pero para nuestra app simple, mejor extraer componentes locales si ya es date object
        if (isNaN(d.getTime())) return dateString;

        // Si tiene hora, asumimos que puede ser UTC o Local.
        // Para simplificar: si viene de DB como DATE puro, mejor tratarlo como string arriba.
        // Si cae acá, es algo más complejo.
        return d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch (e) {
        return dateString;
    }
};
